import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/site";

const SECTIONS = [
  {
    title: "Information we collect",
    body: "Name, email, phone, service interest and any documents you voluntarily share for an engagement — through our website forms, WhatsApp, email or a visit to our office.",
  },
  {
    title: "How we use it",
    body: "To deliver the services you request, communicate updates, comply with statutory requirements and improve what we offer. We never sell personal data to third parties.",
  },
  {
    title: "Data retention",
    body: "We retain client records for the duration mandated by the Income-tax Act, the Companies Act and other applicable statutes — typically eight years.",
  },
  {
    title: "Your rights",
    body: `You may request access, correction or deletion of your data at any time by emailing ${SITE.email}. We respond to every request.`,
  },
  {
    title: "Security",
    body: "Files are stored on encrypted cloud drives with two-factor authentication. Access is limited to engagement-specific team members bound by CA-code confidentiality.",
  },
];

export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Privacy Policy — SAIVU | Saivu Consulting Pvt Ltd"
        description="How SAIVU collects, uses, retains and protects your personal data."
        path="/privacy-policy"
      />
      <section className="bg-white pt-28 pb-24 sm:pt-32" data-testid="privacy-page">
        <div className="mx-auto max-w-3xl px-5 sm:px-6">
          <Reveal>
            <p className="font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-gold-deep">Legal</p>
            <h1 className="mt-5 text-4xl font-bold tracking-tight text-navy-900 sm:text-5xl">Privacy Policy</h1>
            <p className="mt-6 text-base leading-relaxed text-ink">
              {SITE.legalName} values your privacy. This policy explains what data we
              collect, how we use it, and the choices you have.
            </p>
          </Reveal>
          <div className="mt-12 flex flex-col gap-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.04}>
                <h2 className="text-xl font-semibold text-navy-900">{s.title}</h2>
                <p className="mt-3 text-[15px] leading-relaxed text-ink">{s.body}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14">
            <p className="border-t border-line pt-6 font-mono text-xs font-medium uppercase tracking-[0.16em] text-slate-600">
              Last updated: January 2026
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
